const menus = [
  {
    id: 1,
    ingredients: "Pain artisanal, steak frais environ 150g fourré au fromage, sauce barbecue, bacon, oeuf, salade, oignons, cheddar",
    name: "Le Fabrik",
    picture: "https://res.cloudinary.com/suitsconception/image/upload/v1617462204/FabrikBurger/hamburgers/moyenfabrik_ivtf74.jpg",
    pricealacarte: 13,
    priceinMenu: 16,
  },
  {
    id: 2,
    ingredients: "Pain artisanal, steak frais environ 150g, sauce hamburger, guacamole, nachos, poivrons, salade, oignons, emmental",
    name: "Le Mexicain",
    picture: "https://res.cloudinary.com/suitsconception/image/upload/v1617462198/FabrikBurger/hamburgers/moyenmexicainfrites_zz4odh.jpg",
    pricealacarte: 13,
    priceinMenu: 16,
  },
  {
    id: 3,
    ingredients: "Pain artisanal, steak frais environ 150g, sauce smokey honey, bûchette de chèvre, miel, salade, oignons frits, cheddar",
    name: "Le Seguin",
    picture: "https://res.cloudinary.com/suitsconception/image/upload/v1621942554/FabrikBurger/hamburgers/seguin_vvlwyb.jpg",
    pricealacarte: 12,
    priceinMenu: 15,
  },
  {
    id: 4,
    ingredients: "Pain artisanal, steak frais environ 150g, sauce au maroilles maison, maroilles, salade, tomate, oignons, cornichons",
    name: "Le Chti",
    picture: "https://res.cloudinary.com/suitsconception/image/upload/v1617462198/FabrikBurger/hamburgers/moyenchti_s4rgvc.jpg",
    pricealacarte: 13,
    priceinMenu: 16,
  },
  {
    id: 5,
    ingredients: "Pain artisanal, steak frais environ 150g, sauce toscane,  poivrons, salade, tomate, oignons, cheddar",
    name: "Le Classic",
    picture: "https://res.cloudinary.com/suitsconception/image/upload/v1617462203/FabrikBurger/hamburgers/moyenclassic_psv9ne.jpg",
    pricealacarte: 10,
    priceinMenu: 13,
  },
  {
    id: 6,
    ingredients: 'Pain artisanal, poulet curry, sauce "curry-ketchup", aubergine, salade, tomate, oignons, cheddar, emmental',
    name: "L'Indien",
    picture: "https://res.cloudinary.com/suitsconception/image/upload/v1617462202/FabrikBurger/hamburgers/moyenindien_jm0xvn.jpg",
    pricealacarte: 12,
    priceinMenu: 15,
  },
  {
    id: 7,
    ingredients: "Pain artisanal, poulet épicé, sauce maison piquante, salade, tomate, oignons, cheddar",
    name: "Le Spicy",
    picture: "https://res.cloudinary.com/suitsconception/image/upload/v1617462198/FabrikBurger/hamburgers/moyenspicy_cktzjt.jpg",
    pricealacarte: 11,
    priceinMenu: 14,
  },
  {
    id: 8,
    ingredients: "Pain artisanal, poulet assaisonné, sauce tartare, poivrons, salade, tomate, cheddar",
    name: "Le Suprême",
    picture: "https://res.cloudinary.com/suitsconception/image/upload/v1617462201/FabrikBurger/hamburgers/moyensupreme_jma1xu.jpg",
    pricealacarte: 11,
    priceinMenu: 14,
  },
  {
    id: 9,
    ingredients: "Pain artisanal, galette de pomme de terre, sauce tartare, feta, aubergine, poivrons, salade, tomate, oignons",
    name: "Le Végé",
    picture: "https://res.cloudinary.com/suitsconception/image/upload/v1617462197/FabrikBurger/hamburgers/moyenvege_wpvszf.jpg",
    pricealacarte: 9,
    priceinMenu: 12,
  },
  {
    id: 10,
    ingredients: "Pain artisanal, steak frais environ 150g, sauce hamburger, salade, cheddar",
    name: "Le Cheese",
    picture: "https://res.cloudinary.com/suitsconception/image/upload/v1622811430/FabrikBurger/hamburgers/cheese.jpg",
    pricealacarte: 8,
    priceinMenu: 11,
  },
  {
    id: 11,
    ingredients: "Menu enfant avec hamburger steak frais ou poulet ou nuggets de poulet",
    name: "Menu enfant ",
    picture: "https://res.cloudinary.com/suitsconception/image/upload/v1623673285/FabrikBurger/hamburgers/kid_s0wggz.jpg",
    pricealacarte: 7,
    priceinMenu: 10,
  },
];

const adds = [
  {
    id: 1,
    name: "Sauce",
    price: 0.5,
  },
  {
    id: 2,
    name: "Fromage",
    price: 1,
  },
  {
    id: 3,
    name: "Galette de pomme de terre",
    price: 1,
  },
  {
    id: 4,
    name: "Bacon",
    price: 1,
  },
  {
    id: 5,
    name: "Cheddar sur les frites",
    price: 1,
  },
];

const dessertsCard = [
  {
    id: 1,
    name: "Tiramisu maison",
    price: 4,
    description: "",
    picture: "https://res.cloudinary.com/suitsconception/image/upload/v1617462198/FabrikBurger/hamburgers/minitiramisu_roc8ov.jpg",
  },
  {
    id: 4,
    name: "Tarte au Daim",
    price: 4,
    description: "Goût chocolat-caramel",
    picture: "https://res.cloudinary.com/suitsconception/image/upload/v1621510573/FabrikBurger/desserts/la-tarte-au-daim_jmkzbe.jpg",
  },
  {
    id: 2,
    name: "Café",
    price: 2,
    description: "",
    picture: "https://res.cloudinary.com/suitsconception/image/upload/v1617462197/FabrikBurger/hamburgers/caferichard_lmqgkr.jpg",
  },
  {
    id: 3,
    name: "Thé",
    price: 2,
    description: "Infusion à la menthe",
    picture: "https://res.cloudinary.com/suitsconception/image/upload/v1617462198/FabrikBurger/hamburgers/the_wciuao.jpg",
  },
];

const extrasCard = [
  {
    id: 2,
    name: "Tenders au poulet",
    price: 5.5,
    description: "Piquants ou natures",
    picture: "https://res.cloudinary.com/suitsconception/image/upload/v1617462201/FabrikBurger/hamburgers/mozzatenders_qli7au.jpg",
  },
  {
    id: 3,
    name: "Mozza sticks",
    price: 4,
    description: "Mozzarella frit",
    picture: "https://res.cloudinary.com/suitsconception/image/upload/v1617462201/FabrikBurger/hamburgers/mozzatenders_qli7au.jpg",
  },
  {
    id: 1,
    name: "Frites fraîches",
    price: 3,
    description: "",
    picture: "https://res.cloudinary.com/suitsconception/image/upload/v1617462200/FabrikBurger/hamburgers/frites_gys8bv.jpg",
  },
  {
    id: 5,
    name: "Frites au cheddar",
    price: 4,
    description: "",
    picture: "    https://res.cloudinary.com/suitsconception/image/upload/v1617462200/FabrikBurger/hamburgers/cheddar_t36vwm.jpg\n",
  },
];

const boissons = [
  "Eau",
  "S.Pellegrino",
  "Ice Tea",
  "Oasis Tropical",
  "Oasis Pomme cassis framboise",
  "Schweppes Agrumes",
  "Seven Up ",
  "Tropico Exotique",
  "Fanta",
  "Coca",
  "Coca Zéro",
  "Coca Cherry",
];

export { menus, adds, dessertsCard, extrasCard, boissons };
